/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_National_Id_Issued_DateInputs */

const vi_grower_national_id_issued_date = /** @type {(inputs: Grower_National_Id_Issued_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày cấp CCCD`)
};

/**

* @param {Grower_National_Id_Issued_DateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_national_id_issued_date = /** @type {((inputs?: Grower_National_Id_Issued_DateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_National_Id_Issued_DateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_national_id_issued_date(inputs)
});